var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import queryString from 'query-string';
import { ALERTS_PER_DIRECTION, alertsDataDirection as direction } from '../services/core/alerts/alerts.constant';

const clearEmptyParams = params => {
    const keys = Object.keys(params);
    const result = {};
    keys.forEach(key => {
        if (params[key]) {
            result[key] = params[key];
        }
    });

    return result;
};

// get all users
// http://localhost:9001/api/v1/credentials/users/pin

const urlConstant = {
    auth: {
        getStartupDetails: () => `v1/me/activity`,

        check: () => `v1/me/version`,
        // getAllUsers: () =>`/v1/credentials/users`,
        // getAllCredentials: () => `v1/credentials/users/register`,
        // getCredentials: (register) => `v1/credentials/users/register?register=${register}`,

        login: () => `v1/credentials`,
        /*
         * Create user by register from admin, can set username and password
         * */
        registerUser: ({ username, pin }) => `v1/credentials/users/register?pin=${pin}&name=${username}`,

        // reset password (version 1)
        restorePassword: ({ username, pin }) => `v1/credentials/users/reset`, //?pin=${pin}` - for GET,

        /*
         * Generate PIN!
         * Register new user without auth by admin credentials! Login as admin generate new pin then give it to new user
         * Need admin credentials for generating register
         * */
        registerPin: () => `v1/credentials/users/pin`,

        // reset password (version 2)
        // getUserNewPin: () => `v1/credentials/users`,
        getUserNewPin: () => `v1/me/services/UserAdminService/pin/reset`,
        // getUserNewPin: () => `v1/me/services/UserAdminService/pin/register`,
        resetUserPasswordByNewPin: () => `v1/me/services/UserAdminService/pin/reset`

        // register: () => `v1/credentials/users/register`
    },

    core: {
        /* home */
        getHomeStatus: () => {
            return `v1/me/services/UserProfile`;
        },
        setHomeStatus: () => {
            return `v1/me/services/UserProfile/home`;
        },
        getWeatherStatus: () => {
            return `v1/me/services/WeatherService/weather`;
        },

        /* alert/notifications */
        addAlert: () => `v1/me/activity`,
        getAlerts: params => {
            let {
                alertsDataDirection,
                title,
                severity,
                date,
                module,
                limit = ALERTS_PER_DIRECTION
            } = params;

            const dateFilter = {
                from: alertsDataDirection === direction.UP && date, // prev
                to: alertsDataDirection === direction.DOWN && date // next
            };

            const urlParams = queryString.stringify(clearEmptyParams(_extends({}, dateFilter, {
                severity,
                module,
                limit,
                title: '_'
            })));

            return `v1/me/activity?${urlParams}`; // &to=end
        },

        /* control */
        getDeviceList: relation => {
            return `v1/me/appliances/properties/`;
        },
        // gauge chart data
        getDevicesPowerSum: () => {
            return `v1/me/groups/properties/appliances/all/virtual/_/app/P?aggr=sum&show=all&filterout=duplicate`;
        },
        getDevicesPowerLimits: () => {
            return ``;
        },
        getDevicesStatus: () => {
            return `v1/me/groups/properties/appliances/all/virtual/_/app/Ch`;
        },

        /* individual device/appliance */
        getDevice: params => {
            return `v1/me/appliances/properties/${params.deviceId}`;
        },
        getDeviceEnergyChartData: params => {
            const paramsLocal = _extends({}, params);
            const deviceId = paramsLocal.deviceId;
            delete paramsLocal.deviceId;
            delete paramsLocal.type;
            const urlParams = queryString.stringify(clearEmptyParams(paramsLocal));
            return `v1/me/appliances/properties/${deviceId}/virtual/_/app/E_total?${urlParams}`;
        },
        //refresh
        getDeviceStatus: params => {
            return `v1/me/appliances/properties/${params.deviceId}/virtual/_/app/Ch`;
        },
        //refresh
        getDevicePower: params => {
            return `v1/me/appliances/properties/${params.deviceId}/virtual/_/app/P`;
        },
        getDeviceEnergyConsumption: params => {
            const paramsLocal = _extends({}, params);
            const deviceId = paramsLocal.deviceId;
            delete paramsLocal.deviceId;
            const urlParams = queryString.stringify(clearEmptyParams(paramsLocal));
            return `v1/me/appliances/properties/${deviceId}/virtual/_/app/E_total?${urlParams}`;
        },
        setDeviceStatus: params => {
            const deviceId = params.deviceId; //'app_home_PC';
            return `v1/me/services/ApplianceManagerService/control/${deviceId}`;
        },

        /* cost */
        getEnergyChartData: (params, groupName = 'all') => {
            const paramsLocal = _extends({}, params);
            delete paramsLocal.deviceId;
            delete paramsLocal.type;
            const urlParams = queryString.stringify(clearEmptyParams(paramsLocal));
            return `v1/me/groups/properties/appliances/${groupName}/virtual/_/app/E_total?aggr=sum&filterout=duplicate&${urlParams}`;
        },
        getEnergyConsumption: (params, groupName = 'all') => {
            const urlParams = queryString.stringify(clearEmptyParams(params));
            return `v1/me/groups/properties/appliances/${groupName}/virtual/_/app/E_total?aggr=sum&show=all&filterout=duplicate&${urlParams}`;
        }
    },
    service: {
        getSettings: () => `isotel/settings/`
    }
};

export default urlConstant;


// WEBPACK FOOTER //
// ./~/pluton-core/lib/constants/urls.constant.js